import React from "react";

import { isCancelled } from "./occurrenceTimes";

/**
 * Whether a cancelled date stays cancelled when a provider lists it on sale again (`keep_cancelled`,
 * the API's `stamp_cancelled_by`). Shown only on a cancelled date, in both occurrence editors.
 */
export default function KeepCancelledToggle({ occ, onChange }) {
  if (!isCancelled(occ)) return null;
  return (
    <label
      className="flex items-center gap-1 text-xs text-muted-foreground cursor-pointer select-none shrink-0"
      title="Ticked, the date stays cancelled when a provider lists it on sale again. Unticked, the provider's status follows."
    >
      <input
        type="checkbox"
        checked={occ.keep_cancelled !== false}
        onChange={(e) => onChange(e.target.checked)}
        className="accent-primary"
      />
      Keep cancelled
    </label>
  );
}
